var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0415 10C1.0415 5.05068 5.05049 1.04169 9.99984 1.04169C14.9492 1.04169 18.9582 5.05068 18.9582 10C18.9582 14.9494 14.9492 18.9584 9.99984 18.9584C5.05049 18.9584 1.0415 14.9494 1.0415 10Z",
    fill: "#DB3D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8227 7.10863L7.10866 11.8227C6.86458 12.0668 6.86458 12.4625 7.10866 12.7066C7.35274 12.9506 7.74847 12.9506 7.99255 12.7066L12.7066 7.99251C12.9507 7.74843 12.9507 7.35271 12.7066 7.10863C12.4625 6.86455 12.0668 6.86455 11.8227 7.10863Z",
    fill: "#111111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10835 7.99251L11.8224 12.7066C12.0665 12.9506 12.4622 12.9506 12.7063 12.7066C12.9504 12.4625 12.9504 12.0668 12.7063 11.8227L7.99223 7.10863C7.74816 6.86455 7.35243 6.86455 7.10835 7.10863C6.86427 7.35271 6.86427 7.74843 7.10835 7.99251Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/Wrong.6066a869af719dc5258a58d439500905.svg";
export { ForwardRef as ReactComponent };